import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { FunctionComponent } from 'react';

type GridEmptyProps = {
    className?: string;
};

const GridEmpty: FunctionComponent<GridEmptyProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'grid-empty'}
            viewBox="0 0 250 250"
        >
            <path d="M.6.5v107.9h107.9V.5H.6zm99.9 99.9H8.6V8.5h91.9v91.9z" />
            <path d="M141.5.5v107.9h107.9V.5H141.5zm99.9 99.9h-91.9V8.5h91.9v91.9z" />
            <path d="M.6 142v107.9h107.9V142H.6zm99.9 99.9H8.6V150h91.9v91.9z" />
            <path d="M141.5 142v107.9h107.9V142H141.5zm99.9 99.9h-91.9V150h91.9v91.9z" />
        </svg>
    );
};
export default GridEmpty;
